import React, { useMemo } from 'react';

interface VoiceVisualizerProps {
  active: boolean;
  bars?: number;
  className?: string;
}

/**
 * Animated voice waveform. Bars idle at a low height and spring to life with
 * staggered delays while the assistant is listening or speaking.
 */
const VoiceVisualizer: React.FC<VoiceVisualizerProps> = ({ active, bars = 26, className = '' }) => {
  const heights = useMemo(
    () => Array.from({ length: bars }, () => 0.3 + Math.random() * 0.55),
    [bars],
  );

  return (
    <div className={`flex items-center justify-center gap-[3px] h-8 ${className}`}>
      {heights.map((height, index) => (
        <span
          key={index}
          className="w-[3px] rounded-full bg-gradient-to-t from-primary to-secondary"
          style={{
            height: active ? `${Math.round(height * 100)}%` : '22%',
            animation: active ? `wave 0.9s ease-in-out ${(index * 0.05).toFixed(2)}s infinite` : 'none',
            transformOrigin: 'center',
          }}
        />
      ))}
    </div>
  );
};

export default VoiceVisualizer;
